{
  "$schema": "./strings.schema.json",
  "$table": "strings-c04.json",
  "$dialect": "C-04 dialect (ahead of schedule)",
  "$generatedBy": "decoys/generate.mjs",
  "$note": "generated translation dump. the dump wins; hand edits are swept.",
  "entries": {
    "comments.title": "Comments",
    "comments.empty": "Nothing yet. The ferry may be late.",
    "comments.post": "Post comment",
    "comments.placeholder": "Say something the desk can defend.",
    "comments.pending": "Held for moderation. Both of them.",
    "comments.disabled": "Comments are closed on this story. It is happier this way.",
    "comments.moderated": "A moderator read this. The moderator is fine.",
    "comment.reply": "Reply",
    "comment.report": "Report to universe of origin",
    "comment.like": "Duly noted",
    "comments.policy": "House rules: be kind, be legible, be from somewhere.",
    "reader.welcome": "The desk acknowledges you.",
    "reader.farewell": "Understood. Not acted on. Yet.",
    "error.generic": "The ink smudged. Try again.",
    "nav.front": "Front page",
    "nav.editions": "Editions",
    "nav.archive": "Archive",
    "nav.signup": "Sign up",
    "footer.line": "Slow Register — C-04 edition",
    "footer.rights": "All rights reserved, in this universe only.",
    "ui.cta.v1": "Keep reading",
    "ui.cta.v2": "Unfold",
    "ui.cta.v3": "View page",
    "ui.cta.v4": "Continue",
    "ui.cta.v5": "Open edition",
    "ui.cta.v6": "Look inside",
    "ui.cta.v7": "Open edition",
    "ui.cta.v8": "View page",
    "ui.cta.v9": "Go on",
    "ui.cta.v10": "Read",
    "ui.cta.v11": "Keep reading",
    "ui.cta.v12": "Open",
    "ui.cta.v13": "View page",
    "ui.cta.v14": "Keep reading",
    "ui.cta.v15": "View page",
    "ui.cta.v16": "Open edition",
    "ui.cta.v17": "Go on",
    "ui.cta.v18": "View page",
    "ui.cta.v19": "Go on",
    "ui.cta.v20": "Read",
    "ui.cta.v21": "Keep reading",
    "ui.cta.v22": "Open",
    "ui.cta.v23": "Open",
    "ui.cta.v24": "Open",
    "ui.cta.v25": "Continue",
    "ui.cta.v26": "Look inside",
    "ui.cta.v27": "Open edition",
    "ui.cta.v28": "View page",
    "ui.cta.v29": "Go on",
    "ui.cta.v30": "Read",
    "ui.cta.v31": "Keep reading",
    "ui.cta.v32": "Open",
    "ui.cta.v33": "Unfold",
    "ui.cta.v34": "See more",
    "ui.cta.v35": "See more",
    "ui.cta.v36": "Continue",
    "ui.cta.v37": "Open edition",
    "ui.cta.v38": "Unfold",
    "ui.cta.v39": "Go on",
    "ui.cta.v40": "Read",
    "ui.cta.v41": "Read",
    "ui.cta.v42": "Unfold",
    "ui.cta.v43": "Unfold",
    "ui.cta.v44": "Continue",
    "ui.cta.v45": "View page",
    "ui.cta.v46": "Look inside",
    "ui.cta.v47": "Continue",
    "ui.cta.v48": "Open edition",
    "ui.cta.v49": "Go on",
    "ui.cta.v50": "Look inside",
    "ui.cta.v51": "Keep reading",
    "ui.cta.v52": "Open edition",
    "ui.cta.v53": "View page",
    "ui.cta.v54": "Keep reading",
    "ui.cta.v55": "Unfold",
    "ui.cta.v56": "Look inside",
    "ui.cta.v57": "Look inside",
    "ui.cta.v58": "View page",
    "ui.cta.v59": "Unfold",
    "ui.cta.v60": "Read",
    "ui.cta.v61": "Keep reading",
    "ui.cta.v62": "Open",
    "ui.cta.v63": "Open edition",
    "ui.cta.v64": "Continue",
    "ui.cta.v65": "Unfold",
    "ui.cta.v66": "Read",
    "ui.cta.v67": "Open edition",
    "ui.cta.v68": "View page",
    "ui.cta.v69": "Go on",
    "ui.cta.v70": "Read",
    "ui.cta.v71": "Open edition",
    "ui.cta.v72": "See more",
    "ui.cta.v73": "Go on",
    "ui.cta.v74": "Look inside",
    "ui.cta.v75": "View page",
    "ui.cta.v76": "Look inside",
    "ui.cta.v77": "Open edition",
    "ui.cta.v78": "View page",
    "ui.cta.v79": "Keep reading",
    "ui.cta.v80": "Unfold",
    "ui.cta.v81": "Keep reading",
    "ui.cta.v82": "Go on",
    "ui.cta.v83": "Read",
    "ui.cta.v84": "Read",
    "ui.cta.v85": "Continue",
    "ui.cta.v86": "Look inside",
    "ui.cta.v87": "View page",
    "ui.cta.v88": "View page",
    "ui.cta.v89": "Keep reading",
    "ui.cta.v90": "Go on",
    "ui.cta.v91": "Keep reading",
    "ui.cta.v92": "See more",
    "ui.cta.v93": "Unfold",
    "ui.cta.v94": "Read",
    "ui.cta.v95": "See more",
    "ui.cta.v96": "Keep reading",
    "ui.cta.v97": "View page",
    "ui.cta.v98": "View page",
    "ui.cta.v99": "See more",
    "ui.cta.v100": "Keep reading",
    "ui.cta.v101": "Keep reading",
    "ui.cta.v102": "Open",
    "ui.cta.v103": "Go on",
    "ui.cta.v104": "Read",
    "ui.cta.v105": "Open edition",
    "ui.cta.v106": "Look inside",
    "ui.cta.v107": "Open",
    "ui.cta.v108": "View page",
    "ui.cta.v109": "Read",
    "ui.cta.v110": "Read",
    "ui.cta.v111": "Keep reading",
    "ui.cta.v112": "Open edition",
    "ui.cta.v113": "Open edition",
    "ui.cta.v114": "Continue",
    "ui.cta.v115": "Read",
    "ui.cta.v116": "Look inside",
    "ui.cta.v117": "Open edition",
    "ui.cta.v118": "Go on",
    "ui.cta.v119": "Unfold",
    "ui.cta.v120": "See more",
    "ui.cta.v121": "Unfold",
    "ui.cta.v122": "Open edition",
    "ui.cta.v123": "Unfold",
    "ui.cta.v124": "Continue",
    "ui.cta.v125": "Unfold",
    "ui.cta.v126": "Look inside",
    "ui.cta.v127": "Keep reading",
    "ui.cta.v128": "View page",
    "ui.cta.v129": "Go on",
    "ui.cta.v130": "Read",
    "ui.cta.v131": "Keep reading",
    "ui.cta.v132": "Open",
    "ui.cta.v133": "Unfold",
    "ui.cta.v134": "Continue",
    "ui.cta.v135": "See more",
    "ui.toast.v1": "Noted, in the margin.",
    "ui.toast.v2": "Filed under patience.",
    "ui.toast.v3": "Sent. The desk saw it leave.",
    "ui.toast.v4": "Understood. Not acted on. Yet.",
    "ui.toast.v5": "Held for editorial review.",
    "ui.toast.v6": "Synchronized across the corridor.",
    "ui.toast.v7": "Sent. The desk saw it leave.",
    "ui.toast.v8": "Sent. The desk saw it leave.",
    "ui.toast.v9": "Synchronized across the corridor.",
    "ui.toast.v10": "Noted, in the margin.",
    "ui.toast.v11": "Set in ink, provisionally.",
    "ui.toast.v12": "Queued behind two universes.",
    "ui.toast.v13": "Noted, in the margin.",
    "ui.toast.v14": "Filed under patience.",
    "ui.toast.v15": "Printed to the archive of intentions.",
    "ui.toast.v16": "Drafted, with feeling.",
    "ui.toast.v17": "Printed to the archive of intentions.",
    "ui.toast.v18": "Understood. Not acted on. Yet.",
    "ui.toast.v19": "Printed to the archive of intentions.",
    "ui.toast.v20": "Synchronized across the corridor.",
    "ui.toast.v21": "Delivered to your universe of record.",
    "ui.toast.v22": "Sent. The desk saw it leave.",
    "ui.toast.v23": "Synchronized across the corridor.",
    "ui.toast.v24": "Understood. Not acted on. Yet.",
    "ui.toast.v25": "Noted, in the margin.",
    "ui.toast.v26": "Synchronized across the corridor.",
    "ui.toast.v27": "Understood. Not acted on. Yet.",
    "ui.toast.v28": "Understood. Not acted on. Yet.",
    "ui.toast.v29": "Held for editorial review.",
    "ui.toast.v30": "Held for editorial review.",
    "ui.toast.v31": "Sent. The desk saw it leave.",
    "ui.toast.v32": "Drafted, with feeling.",
    "ui.toast.v33": "Saved. Somewhere.",
    "ui.toast.v34": "Understood. Not acted on. Yet.",
    "ui.toast.v35": "Understood. Not acted on. Yet.",
    "ui.toast.v36": "Saved. Somewhere.",
    "ui.toast.v37": "Sent. The desk saw it leave.",
    "ui.toast.v38": "Filed under patience.",
    "ui.toast.v39": "Saved. Somewhere.",
    "ui.toast.v40": "Delivered to your universe of record.",
    "ui.toast.v41": "Held for editorial review.",
    "ui.toast.v42": "Queued behind two universes.",
    "ui.toast.v43": "Sent. The desk saw it leave.",
    "ui.toast.v44": "Drafted, with feeling.",
    "ui.toast.v45": "Synchronized across the corridor.",
    "ui.toast.v46": "Set in ink, provisionally.",
    "ui.toast.v47": "Understood. Not acted on. Yet.",
    "ui.toast.v48": "Saved. Somewhere.",
    "ui.toast.v49": "Noted, in the margin.",
    "ui.toast.v50": "Filed under patience.",
    "ui.toast.v51": "Printed to the archive of intentions.",
    "ui.toast.v52": "Saved. Somewhere.",
    "ui.toast.v53": "Synchronized across the corridor.",
    "ui.toast.v54": "Queued behind two universes.",
    "ui.toast.v55": "Sent. The desk saw it leave.",
    "ui.toast.v56": "Drafted, with feeling.",
    "ui.toast.v57": "Understood. Not acted on. Yet.",
    "ui.toast.v58": "Set in ink, provisionally.",
    "ui.toast.v59": "Understood. Not acted on. Yet.",
    "ui.toast.v60": "Noted, in the margin.",
    "ui.toast.v61": "Noted, in the margin.",
    "ui.toast.v62": "Filed under patience.",
    "ui.toast.v63": "Printed to the archive of intentions.",
    "ui.toast.v64": "Sent. The desk saw it leave.",
    "ui.toast.v65": "Delivered to your universe of record.",
    "ui.toast.v66": "Synchronized across the corridor.",
    "ui.toast.v67": "Noted, in the margin.",
    "ui.toast.v68": "Printed to the archive of intentions.",
    "ui.toast.v69": "Synchronized across the corridor.",
    "ui.toast.v70": "Held for editorial review.",
    "ui.toast.v71": "Understood. Not acted on. Yet.",
    "ui.toast.v72": "Noted, in the margin.",
    "ui.toast.v73": "Noted, in the margin.",
    "ui.toast.v74": "Sent. The desk saw it leave.",
    "ui.toast.v75": "Printed to the archive of intentions.",
    "ui.toast.v76": "Delivered to your universe of record.",
    "ui.toast.v77": "Held for editorial review.",
    "ui.toast.v78": "Queued behind two universes.",
    "ui.toast.v79": "Queued behind two universes.",
    "ui.toast.v80": "Synchronized across the corridor.",
    "ui.toast.v81": "Synchronized across the corridor.",
    "ui.toast.v82": "Sent. The desk saw it leave.",
    "ui.toast.v83": "Queued behind two universes.",
    "ui.toast.v84": "Held for editorial review.",
    "ui.toast.v85": "Noted, in the margin.",
    "ui.toast.v86": "Set in ink, provisionally.",
    "ui.toast.v87": "Understood. Not acted on. Yet.",
    "ui.toast.v88": "Noted, in the margin.",
    "ui.toast.v89": "Held for editorial review.",
    "ui.toast.v90": "Queued behind two universes.",
    "ui.toast.v91": "Synchronized across the corridor.",
    "ui.toast.v92": "Drafted, with feeling.",
    "ui.toast.v93": "Synchronized across the corridor.",
    "ui.toast.v94": "Set in ink, provisionally.",
    "ui.toast.v95": "Drafted, with feeling.",
    "ui.toast.v96": "Set in ink, provisionally.",
    "ui.toast.v97": "Noted, in the margin.",
    "ui.toast.v98": "Set in ink, provisionally.",
    "ui.toast.v99": "Saved. Somewhere.",
    "ui.toast.v100": "Understood. Not acted on. Yet.",
    "ui.toast.v101": "Drafted, with feeling.",
    "ui.toast.v102": "Drafted, with feeling.",
    "ui.toast.v103": "Sent. The desk saw it leave.",
    "ui.toast.v104": "Printed to the archive of intentions.",
    "ui.toast.v105": "Drafted, with feeling.",
    "ui.toast.v106": "Sent. The desk saw it leave.",
    "ui.toast.v107": "Understood. Not acted on. Yet.",
    "ui.toast.v108": "Saved. Somewhere.",
    "ui.toast.v109": "Noted, in the margin.",
    "ui.toast.v110": "Filed under patience.",
    "ui.toast.v111": "Printed to the archive of intentions.",
    "ui.toast.v112": "Sent. The desk saw it leave.",
    "ui.toast.v113": "Filed under patience.",
    "ui.toast.v114": "Queued behind two universes.",
    "ui.toast.v115": "Held for editorial review.",
    "ui.toast.v116": "Drafted, with feeling.",
    "ui.toast.v117": "Queued behind two universes.",
    "ui.toast.v118": "Set in ink, provisionally.",
    "ui.toast.v119": "Understood. Not acted on. Yet.",
    "ui.toast.v120": "Understood. Not acted on. Yet.",
    "ui.toast.v121": "Saved. Somewhere.",
    "ui.toast.v122": "Filed under patience.",
    "ui.toast.v123": "Sent. The desk saw it leave.",
    "ui.toast.v124": "Sent. The desk saw it leave.",
    "ui.toast.v125": "Sent. The desk saw it leave.",
    "ui.toast.v126": "Filed under patience.",
    "ui.toast.v127": "Sent. The desk saw it leave.",
    "ui.toast.v128": "Synchronized across the corridor.",
    "ui.toast.v129": "Synchronized across the corridor.",
    "ui.toast.v130": "Delivered to your universe of record.",
    "ui.toast.v131": "Sent. The desk saw it leave.",
    "ui.toast.v132": "Filed under patience.",
    "ui.toast.v133": "Delivered to your universe of record.",
    "ui.toast.v134": "Filed under patience.",
    "ui.toast.v135": "Drafted, with feeling.",
    "greeting.formal.v1": "Your universe of record stands confirmed.",
    "greeting.formal.v2": "The paper remembers you fondly.",
    "greeting.formal.v3": "Welcome back, presumably.",
    "greeting.formal.v4": "Your universe of record stands confirmed.",
    "greeting.formal.v5": "The paper remembers you fondly.",
    "greeting.formal.v6": "Good day. It is a news day.",
    "greeting.formal.v7": "Good day. It is a news day.",
    "greeting.formal.v8": "We read you with both eyes open.",
    "greeting.formal.v9": "The desk acknowledges you.",
    "greeting.formal.v10": "The paper remembers you fondly.",
    "greeting.formal.v11": "We read you with both eyes open.",
    "greeting.formal.v12": "The desk acknowledges you.",
    "greeting.formal.v13": "The paper remembers you fondly.",
    "greeting.formal.v14": "The paper remembers you fondly.",
    "greeting.formal.v15": "Good day. It is a news day.",
    "greeting.formal.v16": "We read you with both eyes open.",
    "greeting.formal.v17": "Good day. It is a news day.",
    "greeting.formal.v18": "You are among readers.",
    "greeting.formal.v19": "Welcome back, presumably.",
    "greeting.formal.v20": "The paper remembers you fondly.",
    "greeting.formal.v21": "You are among readers.",
    "greeting.formal.v22": "Good day. It is a news day.",
    "greeting.formal.v23": "The paper remembers you fondly.",
    "greeting.formal.v24": "Welcome back, presumably.",
    "greeting.formal.v25": "The desk acknowledges you.",
    "greeting.formal.v26": "Your universe of record stands confirmed.",
    "greeting.formal.v27": "Welcome back, presumably.",
    "greeting.formal.v28": "Your universe of record stands confirmed.",
    "greeting.formal.v29": "The paper remembers you fondly.",
    "greeting.formal.v30": "Good day. It is a news day.",
    "greeting.formal.v31": "You are receiving this correctly.",
    "greeting.formal.v32": "We read you with both eyes open.",
    "greeting.formal.v33": "The desk acknowledges you.",
    "greeting.formal.v34": "Good day. It is a news day.",
    "greeting.formal.v35": "You are receiving this correctly.",
    "greeting.formal.v36": "Your universe of record stands confirmed.",
    "greeting.formal.v37": "The paper remembers you fondly.",
    "greeting.formal.v38": "Your universe of record stands confirmed.",
    "greeting.formal.v39": "Your universe of record stands confirmed.",
    "greeting.formal.v40": "The desk acknowledges you.",
    "greeting.formal.v41": "Good day. It is a news day.",
    "greeting.formal.v42": "You are among readers.",
    "greeting.formal.v43": "Welcome back, presumably.",
    "greeting.formal.v44": "You are receiving this correctly.",
    "greeting.formal.v45": "The desk acknowledges you.",
    "greeting.formal.v46": "The paper remembers you fondly.",
    "greeting.formal.v47": "You are receiving this correctly.",
    "greeting.formal.v48": "Your universe of record stands confirmed.",
    "greeting.formal.v49": "The desk acknowledges you.",
    "greeting.formal.v50": "You are among readers.",
    "greeting.formal.v51": "Welcome back, presumably.",
    "greeting.formal.v52": "You are receiving this correctly.",
    "greeting.formal.v53": "The paper remembers you fondly.",
    "greeting.formal.v54": "Good day. It is a news day.",
    "greeting.formal.v55": "You are receiving this correctly.",
    "greeting.formal.v56": "You are receiving this correctly.",
    "greeting.formal.v57": "We read you with both eyes open.",
    "greeting.formal.v58": "The desk acknowledges you.",
    "greeting.formal.v59": "Welcome back, presumably.",
    "greeting.formal.v60": "Your universe of record stands confirmed.",
    "greeting.formal.v61": "The paper remembers you fondly.",
    "greeting.formal.v62": "Welcome back, presumably.",
    "greeting.formal.v63": "You are receiving this correctly.",
    "greeting.formal.v64": "Welcome back, presumably.",
    "greeting.formal.v65": "The desk acknowledges you.",
    "greeting.formal.v66": "We read you with both eyes open.",
    "greeting.formal.v67": "The desk acknowledges you.",
    "greeting.formal.v68": "You are among readers.",
    "greeting.formal.v69": "The paper remembers you fondly.",
    "greeting.formal.v70": "We read you with both eyes open.",
    "greeting.formal.v71": "You are receiving this correctly.",
    "greeting.formal.v72": "You are among readers.",
    "greeting.formal.v73": "The paper remembers you fondly.",
    "greeting.formal.v74": "You are receiving this correctly.",
    "greeting.formal.v75": "Your universe of record stands confirmed.",
    "greeting.formal.v76": "Your universe of record stands confirmed.",
    "greeting.formal.v77": "The paper remembers you fondly.",
    "greeting.formal.v78": "Good day. It is a news day.",
    "greeting.formal.v79": "The paper remembers you fondly.",
    "greeting.formal.v80": "You are among readers.",
    "greeting.formal.v81": "You are among readers.",
    "greeting.formal.v82": "The desk acknowledges you.",
    "greeting.formal.v83": "Welcome back, presumably.",
    "greeting.formal.v84": "You are receiving this correctly.",
    "greeting.formal.v85": "Good day. It is a news day.",
    "greeting.formal.v86": "We read you with both eyes open.",
    "greeting.formal.v87": "We read you with both eyes open.",
    "greeting.formal.v88": "We read you with both eyes open.",
    "greeting.formal.v89": "We read you with both eyes open.",
    "greeting.formal.v90": "You are among readers.",
    "error.soft.v1": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v2": "That failed quietly, as designed.",
    "error.soft.v3": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v4": "The ink smudged. Try again.",
    "error.soft.v5": "The ink smudged. Try again.",
    "error.soft.v6": "Something did not happen. The desk is informed.",
    "error.soft.v7": "That failed quietly, as designed.",
    "error.soft.v8": "That failed quietly, as designed.",
    "error.soft.v9": "That failed quietly, as designed.",
    "error.soft.v10": "This did not work. It did not work politely.",
    "error.soft.v11": "This did not work. It did not work politely.",
    "error.soft.v12": "That failed quietly, as designed.",
    "error.soft.v13": "The page declined. No feelings involved.",
    "error.soft.v14": "The page declined. No feelings involved.",
    "error.soft.v15": "Something did not happen. The desk is informed.",
    "error.soft.v16": "The page declined. No feelings involved.",
    "error.soft.v17": "The ink smudged. Try again.",
    "error.soft.v18": "The ink smudged. Try again.",
    "error.soft.v19": "This did not work. It did not work politely.",
    "error.soft.v20": "The page declined. No feelings involved.",
    "error.soft.v21": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v22": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v23": "This did not work. It did not work politely.",
    "error.soft.v24": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v25": "This did not work. It did not work politely.",
    "error.soft.v26": "The page declined. No feelings involved.",
    "error.soft.v27": "This did not work. It did not work politely.",
    "error.soft.v28": "The ink smudged. Try again.",
    "error.soft.v29": "This did not work. It did not work politely.",
    "error.soft.v30": "Something did not happen. The desk is informed.",
    "error.soft.v31": "That failed quietly, as designed.",
    "error.soft.v32": "Something did not happen. The desk is informed.",
    "error.soft.v33": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v34": "The ink smudged. Try again.",
    "error.soft.v35": "This did not work. It did not work politely.",
    "error.soft.v36": "The ink smudged. Try again.",
    "error.soft.v37": "The ink smudged. Try again.",
    "error.soft.v38": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v39": "The ink smudged. Try again.",
    "error.soft.v40": "Something did not happen. The desk is informed.",
    "error.soft.v41": "This did not work. It did not work politely.",
    "error.soft.v42": "Something did not happen. The desk is informed.",
    "error.soft.v43": "That failed quietly, as designed.",
    "error.soft.v44": "The ink smudged. Try again.",
    "error.soft.v45": "The ink smudged. Try again.",
    "error.soft.v46": "This did not work. It did not work politely.",
    "error.soft.v47": "This did not work. It did not work politely.",
    "error.soft.v48": "Something did not happen. The desk is informed.",
    "error.soft.v49": "The ink smudged. Try again.",
    "error.soft.v50": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v51": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v52": "The ink smudged. Try again.",
    "error.soft.v53": "Something did not happen. The desk is informed.",
    "error.soft.v54": "The page declined. No feelings involved.",
    "error.soft.v55": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v56": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v57": "The ink smudged. Try again.",
    "error.soft.v58": "The ink smudged. Try again.",
    "error.soft.v59": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v60": "That failed quietly, as designed.",
    "error.soft.v61": "The ink smudged. Try again.",
    "error.soft.v62": "The page declined. No feelings involved.",
    "error.soft.v63": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v64": "That failed quietly, as designed.",
    "error.soft.v65": "This did not work. It did not work politely.",
    "error.soft.v66": "Something did not happen. The desk is informed.",
    "error.soft.v67": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v68": "The page declined. No feelings involved.",
    "error.soft.v69": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v70": "The page declined. No feelings involved.",
    "error.soft.v71": "The page declined. No feelings involved.",
    "error.soft.v72": "The page declined. No feelings involved.",
    "error.soft.v73": "That failed quietly, as designed.",
    "error.soft.v74": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v75": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v76": "The ink smudged. Try again.",
    "error.soft.v77": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v78": "The page declined. No feelings involved.",
    "error.soft.v79": "This did not work. It did not work politely.",
    "error.soft.v80": "The page declined. No feelings involved.",
    "error.soft.v81": "The page declined. No feelings involved.",
    "error.soft.v82": "The ink smudged. Try again.",
    "error.soft.v83": "This did not work. It did not work politely.",
    "error.soft.v84": "Something did not happen. The desk is informed.",
    "error.soft.v85": "That failed quietly, as designed.",
    "error.soft.v86": "The page declined. No feelings involved.",
    "error.soft.v87": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v88": "Something did not happen. The desk is informed.",
    "error.soft.v89": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v90": "Something did not happen. The desk is informed.",
    "empty.state.v1": "Nothing here. The desk is grateful.",
    "empty.state.v2": "No entries. Consider writing one.",
    "empty.state.v3": "Blank, but typeset.",
    "empty.state.v4": "Nothing yet. The ferry may be late.",
    "empty.state.v5": "Nothing yet. The ferry may be late.",
    "empty.state.v6": "Empty, like the print room on Sundays.",
    "empty.state.v7": "Blank, but typeset.",
    "empty.state.v8": "Blank, but typeset.",
    "empty.state.v9": "Nothing yet. The ferry may be late.",
    "empty.state.v10": "Nothing here. The desk is grateful.",
    "empty.state.v11": "Blank, but typeset.",
    "empty.state.v12": "No entries. Consider writing one.",
    "empty.state.v13": "No entries. Consider writing one.",
    "empty.state.v14": "Empty, like the print room on Sundays.",
    "empty.state.v15": "No entries. Consider writing one.",
    "empty.state.v16": "Empty, like the print room on Sundays.",
    "empty.state.v17": "No entries. Consider writing one.",
    "empty.state.v18": "Nothing here. The desk is grateful.",
    "empty.state.v19": "No entries. Consider writing one.",
    "empty.state.v20": "Blank, but typeset.",
    "empty.state.v21": "Empty, like the print room on Sundays.",
    "empty.state.v22": "No entries. Consider writing one.",
    "empty.state.v23": "Empty, like the print room on Sundays.",
    "empty.state.v24": "Nothing yet. The ferry may be late.",
    "empty.state.v25": "Nothing here. The desk is grateful.",
    "empty.state.v26": "Nothing here. The desk is grateful.",
    "empty.state.v27": "No entries. Consider writing one.",
    "empty.state.v28": "Blank, but typeset.",
    "empty.state.v29": "No entries. Consider writing one.",
    "empty.state.v30": "Nothing here. The desk is grateful.",
    "empty.state.v31": "Blank, but typeset.",
    "empty.state.v32": "Blank, but typeset.",
    "empty.state.v33": "Blank, but typeset.",
    "empty.state.v34": "Nothing yet. The ferry may be late.",
    "empty.state.v35": "Nothing here. The desk is grateful.",
    "empty.state.v36": "No entries. Consider writing one.",
    "empty.state.v37": "Nothing yet. The ferry may be late.",
    "empty.state.v38": "Blank, but typeset.",
    "empty.state.v39": "No entries. Consider writing one.",
    "empty.state.v40": "Nothing here. The desk is grateful.",
    "empty.state.v41": "Empty, like the print room on Sundays.",
    "empty.state.v42": "No entries. Consider writing one.",
    "empty.state.v43": "Blank, but typeset.",
    "empty.state.v44": "Nothing yet. The ferry may be late.",
    "empty.state.v45": "Nothing here. The desk is grateful.",
    "empty.state.v46": "Nothing yet. The ferry may be late.",
    "empty.state.v47": "No entries. Consider writing one.",
    "empty.state.v48": "Blank, but typeset.",
    "empty.state.v49": "Nothing yet. The ferry may be late.",
    "empty.state.v50": "Nothing yet. The ferry may be late.",
    "empty.state.v51": "Empty, like the print room on Sundays.",
    "empty.state.v52": "No entries. Consider writing one.",
    "empty.state.v53": "Nothing yet. The ferry may be late.",
    "empty.state.v54": "Nothing yet. The ferry may be late.",
    "empty.state.v55": "Blank, but typeset.",
    "empty.state.v56": "Nothing yet. The ferry may be late.",
    "empty.state.v57": "Nothing yet. The ferry may be late.",
    "empty.state.v58": "No entries. Consider writing one.",
    "empty.state.v59": "No entries. Consider writing one.",
    "empty.state.v60": "Nothing here. The desk is grateful.",
    "empty.state.v61": "Empty, like the print room on Sundays.",
    "empty.state.v62": "Empty, like the print room on Sundays.",
    "empty.state.v63": "Nothing yet. The ferry may be late.",
    "empty.state.v64": "Blank, but typeset.",
    "empty.state.v65": "Nothing here. The desk is grateful.",
    "empty.state.v66": "Nothing here. The desk is grateful.",
    "empty.state.v67": "No entries. Consider writing one.",
    "empty.state.v68": "Blank, but typeset.",
    "empty.state.v69": "Nothing here. The desk is grateful.",
    "empty.state.v70": "Nothing here. The desk is grateful.",
    "empty.state.v71": "Empty, like the print room on Sundays.",
    "empty.state.v72": "No entries. Consider writing one.",
    "empty.state.v73": "Empty, like the print room on Sundays.",
    "empty.state.v74": "Nothing here. The desk is grateful.",
    "empty.state.v75": "Nothing here. The desk is grateful.",
    "confirm.done.v1": "Confirmed. You may proceed being right.",
    "confirm.done.v2": "Confirmed. You may proceed being right.",
    "confirm.done.v3": "Confirmed and initialled.",
    "confirm.done.v4": "Confirmed and initialled.",
    "confirm.done.v5": "Confirmed. The universe has been told.",
    "confirm.done.v6": "Confirmed. You may proceed being right.",
    "confirm.done.v7": "Confirmed and initialled.",
    "confirm.done.v8": "Recorded in both ledgers.",
    "confirm.done.v9": "Confirmed and initialled.",
    "confirm.done.v10": "Confirmed and initialled.",
    "confirm.done.v11": "Confirmed twice, for the archive.",
    "confirm.done.v12": "Confirmed. You may proceed being right.",
    "confirm.done.v13": "Recorded in both ledgers.",
    "confirm.done.v14": "Confirmed and initialled.",
    "confirm.done.v15": "Confirmed. The universe has been told.",
    "confirm.done.v16": "Confirmed. The universe has been told.",
    "confirm.done.v17": "Confirmed. You may proceed being right.",
    "confirm.done.v18": "Confirmed twice, for the archive.",
    "confirm.done.v19": "Confirmed. The universe has been told.",
    "confirm.done.v20": "Confirmed. You may proceed being right.",
    "confirm.done.v21": "Confirmed twice, for the archive.",
    "confirm.done.v22": "Confirmed and initialled.",
    "confirm.done.v23": "Confirmed and initialled.",
    "confirm.done.v24": "Confirmed. The universe has been told.",
    "confirm.done.v25": "Confirmed. The universe has been told.",
    "confirm.done.v26": "Confirmed and initialled.",
    "confirm.done.v27": "Confirmed. You may proceed being right.",
    "confirm.done.v28": "Confirmed twice, for the archive.",
    "confirm.done.v29": "Recorded in both ledgers.",
    "confirm.done.v30": "Recorded in both ledgers.",
    "confirm.done.v31": "Confirmed. The universe has been told.",
    "confirm.done.v32": "Confirmed. You may proceed being right.",
    "confirm.done.v33": "Recorded in both ledgers.",
    "confirm.done.v34": "Recorded in both ledgers.",
    "confirm.done.v35": "Confirmed. You may proceed being right.",
    "confirm.done.v36": "Confirmed and initialled.",
    "confirm.done.v37": "Confirmed. You may proceed being right.",
    "confirm.done.v38": "Confirmed. The universe has been told.",
    "confirm.done.v39": "Confirmed and initialled.",
    "confirm.done.v40": "Confirmed and initialled.",
    "confirm.done.v41": "Confirmed twice, for the archive.",
    "confirm.done.v42": "Confirmed. You may proceed being right.",
    "confirm.done.v43": "Recorded in both ledgers.",
    "confirm.done.v44": "Confirmed. The universe has been told.",
    "confirm.done.v45": "Confirmed. You may proceed being right.",
    "confirm.done.v46": "Confirmed twice, for the archive.",
    "confirm.done.v47": "Confirmed twice, for the archive.",
    "confirm.done.v48": "Recorded in both ledgers.",
    "confirm.done.v49": "Confirmed and initialled.",
    "confirm.done.v50": "Confirmed. The universe has been told.",
    "confirm.done.v51": "Confirmed twice, for the archive.",
    "confirm.done.v52": "Confirmed. You may proceed being right.",
    "confirm.done.v53": "Confirmed twice, for the archive.",
    "confirm.done.v54": "Confirmed twice, for the archive.",
    "confirm.done.v55": "Confirmed. The universe has been told.",
    "confirm.done.v56": "Confirmed twice, for the archive.",
    "confirm.done.v57": "Confirmed. You may proceed being right.",
    "confirm.done.v58": "Recorded in both ledgers.",
    "confirm.done.v59": "Confirmed and initialled.",
    "confirm.done.v60": "Confirmed. The universe has been told.",
    "confirm.done.v61": "Confirmed twice, for the archive.",
    "confirm.done.v62": "Confirmed. You may proceed being right.",
    "confirm.done.v63": "Recorded in both ledgers.",
    "confirm.done.v64": "Confirmed and initialled.",
    "confirm.done.v65": "Confirmed. The universe has been told.",
    "confirm.done.v66": "Confirmed. The universe has been told.",
    "confirm.done.v67": "Confirmed twice, for the archive.",
    "confirm.done.v68": "Confirmed. You may proceed being right.",
    "confirm.done.v69": "Confirmed and initialled.",
    "confirm.done.v70": "Confirmed. You may proceed being right.",
    "confirm.done.v71": "Recorded in both ledgers.",
    "confirm.done.v72": "Confirmed. The universe has been told.",
    "confirm.done.v73": "Recorded in both ledgers.",
    "confirm.done.v74": "Confirmed and initialled.",
    "confirm.done.v75": "Confirmed. The universe has been told.",
    "reader.title.v1": "Subscriber",
    "reader.title.v2": "Passerby",
    "reader.title.v3": "Correspondent",
    "reader.title.v4": "Capsule witness",
    "reader.title.v5": "Friend of the drawer",
    "reader.title.v6": "Keeper of the ledger",
    "reader.title.v7": "Reader",
    "reader.title.v8": "Patron of the print",
    "reader.title.v9": "Adjacent reader",
    "reader.title.v10": "Adjacent reader",
    "reader.title.v11": "Subscriber",
    "reader.title.v12": "Friend of the drawer",
    "reader.title.v13": "Bridge member",
    "reader.title.v14": "Adjacent reader",
    "reader.title.v15": "Bridge member",
    "reader.title.v16": "Keeper of the ledger",
    "reader.title.v17": "Patron of the print",
    "reader.title.v18": "Capsule witness",
    "reader.title.v19": "Bridge member",
    "reader.title.v20": "Reader",
    "reader.title.v21": "Bridge member",
    "reader.title.v22": "Passerby",
    "reader.title.v23": "Correspondent",
    "reader.title.v24": "Patron of the print",
    "reader.title.v25": "Friend of the drawer",
    "reader.title.v26": "Correspondent",
    "reader.title.v27": "Keeper of the ledger",
    "reader.title.v28": "Adjacent reader",
    "reader.title.v29": "Friend of the drawer",
    "reader.title.v30": "Reader",
    "reader.title.v31": "Subscriber",
    "reader.title.v32": "Passerby",
    "reader.title.v33": "Passerby",
    "reader.title.v34": "Patron of the print",
    "reader.title.v35": "Friend of the drawer",
    "reader.title.v36": "Reader",
    "reader.title.v37": "Capsule witness",
    "reader.title.v38": "Adjacent reader",
    "reader.title.v39": "Adjacent reader",
    "reader.title.v40": "Reader",
    "reader.title.v41": "Reader",
    "reader.title.v42": "Keeper of the ledger",
    "reader.title.v43": "Correspondent",
    "reader.title.v44": "Subscriber",
    "reader.title.v45": "Friend of the drawer",
    "reader.title.v46": "Bridge member",
    "reader.title.v47": "Friend of the drawer",
    "reader.title.v48": "Bridge member",
    "reader.title.v49": "Patron of the print",
    "reader.title.v50": "Passerby",
    "reader.title.v51": "Subscriber",
    "reader.title.v52": "Friend of the drawer",
    "reader.title.v53": "Reader",
    "reader.title.v54": "Keeper of the ledger",
    "reader.title.v55": "Friend of the drawer",
    "reader.title.v56": "Patron of the print",
    "reader.title.v57": "Capsule witness",
    "reader.title.v58": "Bridge member",
    "reader.title.v59": "Adjacent reader",
    "reader.title.v60": "Passerby",
    "reader.title.v61": "Capsule witness",
    "reader.title.v62": "Friend of the drawer",
    "reader.title.v63": "Keeper of the ledger",
    "reader.title.v64": "Patron of the print",
    "reader.title.v65": "Friend of the drawer",
    "reader.title.v66": "Correspondent",
    "reader.title.v67": "Reader",
    "reader.title.v68": "Bridge member",
    "reader.title.v69": "Adjacent reader",
    "reader.title.v70": "Bridge member",
    "reader.title.v71": "Subscriber",
    "reader.title.v72": "Subscriber",
    "reader.title.v73": "Correspondent",
    "reader.title.v74": "Patron of the print",
    "reader.title.v75": "Subscriber",
    "reader.title.v76": "Keeper of the ledger",
    "reader.title.v77": "Capsule witness",
    "reader.title.v78": "Bridge member",
    "reader.title.v79": "Friend of the drawer",
    "reader.title.v80": "Friend of the drawer",
    "reader.title.v81": "Subscriber",
    "reader.title.v82": "Passerby",
    "reader.title.v83": "Correspondent",
    "reader.title.v84": "Friend of the drawer",
    "reader.title.v85": "Correspondent",
    "reader.title.v86": "Correspondent",
    "reader.title.v87": "Correspondent",
    "reader.title.v88": "Bridge member",
    "reader.title.v89": "Adjacent reader",
    "reader.title.v90": "Reader",
    "reader.title.v91": "Correspondent",
    "reader.title.v92": "Passerby",
    "reader.title.v93": "Correspondent",
    "reader.title.v94": "Reader",
    "reader.title.v95": "Friend of the drawer",
    "reader.title.v96": "Adjacent reader",
    "reader.title.v97": "Capsule witness",
    "reader.title.v98": "Bridge member",
    "reader.title.v99": "Bridge member",
    "reader.title.v100": "Reader",
    "reader.title.v101": "Subscriber",
    "reader.title.v102": "Passerby",
    "reader.title.v103": "Friend of the drawer",
    "reader.title.v104": "Patron of the print",
    "reader.title.v105": "Passerby",
    "signup.title.v1": "Reader record",
    "signup.title.v2": "Free reader registration",
    "signup.title.v3": "Join the readership",
    "signup.title.v4": "Become a reader",
    "signup.title.v5": "Free reader registration",
    "signup.title.v6": "The signup",
    "signup.title.v7": "The signup",
    "signup.title.v8": "Become a reader",
    "signup.title.v9": "Sign up, simply",
    "signup.title.v10": "Sign up to keep reading",
    "signup.title.v11": "Registration, gently",
    "signup.title.v12": "Sign up, simply",
    "signup.title.v13": "Join the readership",
    "signup.title.v14": "Readers like you",
    "signup.title.v15": "Become a reader",
    "signup.title.v16": "Readers like you",
    "signup.title.v17": "Reader record",
    "signup.title.v18": "Join us in reading",
    "signup.title.v19": "Readers like you",
    "signup.title.v20": "Sign up to keep reading",
    "signup.title.v21": "Become a reader",
    "signup.title.v22": "Readers like you",
    "signup.title.v23": "Free reader registration",
    "signup.title.v24": "Become a reader",
    "signup.title.v25": "Registration, gently",
    "signup.title.v26": "Sign up, simply",
    "signup.title.v27": "Sign up to keep reading",
    "signup.title.v28": "Join the readership",
    "signup.title.v29": "Become a reader",
    "signup.title.v30": "Sign up to keep reading",
    "signup.title.v31": "Free reader registration",
    "signup.title.v32": "The signup",
    "signup.title.v33": "Join the readership",
    "signup.title.v34": "Sign up, simply",
    "signup.title.v35": "Free reader registration",
    "signup.title.v36": "Free reader registration",
    "signup.title.v37": "Reader record",
    "signup.title.v38": "Join us in reading",
    "signup.title.v39": "Reader record",
    "signup.title.v40": "Sign up to keep reading",
    "signup.title.v41": "Registration, gently",
    "signup.title.v42": "Free reader registration",
    "signup.title.v43": "Readers like you",
    "signup.title.v44": "Become a reader",
    "signup.title.v45": "Free reader registration",
    "signup.title.v46": "Sign up, simply",
    "signup.title.v47": "Reader record",
    "signup.title.v48": "Join us in reading",
    "signup.title.v49": "The signup",
    "signup.title.v50": "Sign up to keep reading",
    "signup.title.v51": "Join us in reading",
    "signup.title.v52": "Sign up, simply",
    "signup.title.v53": "Join the readership",
    "signup.title.v54": "Become a reader",
    "signup.title.v55": "Sign up to keep reading",
    "signup.title.v56": "Free reader registration",
    "signup.title.v57": "Reader record",
    "signup.title.v58": "Join us in reading",
    "signup.title.v59": "The signup",
    "signup.title.v60": "Sign up, simply",
    "signup.title.v61": "Registration, gently",
    "signup.title.v62": "The signup",
    "signup.title.v63": "Join the readership",
    "signup.title.v64": "Registration, gently",
    "signup.title.v65": "Free reader registration",
    "signup.title.v66": "Sign up, simply",
    "signup.title.v67": "Free reader registration",
    "signup.title.v68": "Join us in reading",
    "signup.title.v69": "Sign up, simply",
    "signup.title.v70": "Registration, gently",
    "signup.title.v71": "Sign up to keep reading",
    "signup.title.v72": "Free reader registration",
    "signup.title.v73": "Join the readership",
    "signup.title.v74": "Free reader registration",
    "signup.title.v75": "Join the readership",
    "signup.title.v76": "Readers like you",
    "signup.title.v77": "Sign up, simply",
    "signup.title.v78": "Join us in reading",
    "signup.title.v79": "The signup",
    "signup.title.v80": "Join the readership",
    "signup.title.v81": "Sign up, simply",
    "signup.title.v82": "Registration, gently",
    "signup.title.v83": "Join the readership",
    "signup.title.v84": "Become a reader",
    "signup.title.v85": "Free reader registration",
    "signup.title.v86": "Sign up to keep reading",
    "signup.title.v87": "Reader record",
    "signup.title.v88": "Reader record",
    "signup.title.v89": "The signup",
    "signup.title.v90": "Free reader registration",
    "paywall.line.v1": "Subscription pending review.",
    "paywall.line.v2": "Reviews take universes.",
    "paywall.line.v3": "Continue behind the desk.",
    "paywall.line.v4": "Continue behind the desk.",
    "paywall.line.v5": "Reviews take universes.",
    "paywall.line.v6": "Reading beyond costs patience.",
    "paywall.line.v7": "Reading beyond costs patience.",
    "paywall.line.v8": "Approval takes time and universes.",
    "paywall.line.v9": "The teaser is the free part.",
    "paywall.line.v10": "Reviews take universes.",
    "paywall.line.v11": "Subscription pending review.",
    "paywall.line.v12": "Reviews take universes.",
    "paywall.line.v13": "Reviews take universes.",
    "paywall.line.v14": "Continue behind the desk.",
    "paywall.line.v15": "The desk holds the line.",
    "paywall.line.v16": "Continue behind the desk.",
    "paywall.line.v17": "The desk holds the line.",
    "paywall.line.v18": "Subscription pending review.",
    "paywall.line.v19": "Nothing personal. Policy.",
    "paywall.line.v20": "The wall remains a wall.",
    "paywall.line.v21": "Subscription pending review.",
    "paywall.line.v22": "Reviews take universes.",
    "paywall.line.v23": "The teaser is the free part.",
    "paywall.line.v24": "Continue behind the desk.",
    "paywall.line.v25": "The desk holds the line.",
    "paywall.line.v26": "Reading beyond costs patience.",
    "paywall.line.v27": "The rest is membership.",
    "paywall.line.v28": "Approval takes time and universes.",
    "paywall.line.v29": "Approval takes time and universes.",
    "paywall.line.v30": "The wall remains a wall.",
    "paywall.line.v31": "The desk holds the line.",
    "paywall.line.v32": "Continue behind the desk.",
    "paywall.line.v33": "The teaser is the free part.",
    "paywall.line.v34": "Continue behind the desk.",
    "paywall.line.v35": "Reading beyond costs patience.",
    "paywall.line.v36": "Continue behind the desk.",
    "paywall.line.v37": "The desk holds the line.",
    "paywall.line.v38": "The wall remains a wall.",
    "paywall.line.v39": "Nothing personal. Policy.",
    "paywall.line.v40": "The rest is membership.",
    "paywall.line.v41": "Subscription pending review.",
    "paywall.line.v42": "Reviews take universes.",
    "paywall.line.v43": "The teaser is the free part.",
    "paywall.line.v44": "Nothing personal. Policy.",
    "paywall.line.v45": "The rest is membership.",
    "paywall.line.v46": "Reading beyond costs patience.",
    "paywall.line.v47": "Reading beyond costs patience.",
    "paywall.line.v48": "Approval takes time and universes.",
    "paywall.line.v49": "Nothing personal. Policy.",
    "paywall.line.v50": "The wall remains a wall.",
    "paywall.line.v51": "The rest is membership.",
    "paywall.line.v52": "The wall remains a wall.",
    "paywall.line.v53": "The teaser is the free part.",
    "paywall.line.v54": "Continue behind the desk.",
    "paywall.line.v55": "The wall remains a wall.",
    "paywall.line.v56": "Subscription pending review.",
    "paywall.line.v57": "The desk holds the line.",
    "paywall.line.v58": "Approval takes time and universes.",
    "paywall.line.v59": "The rest is membership.",
    "paywall.line.v60": "The rest is membership.",
    "paywall.line.v61": "Continue behind the desk.",
    "paywall.line.v62": "Reviews take universes.",
    "paywall.line.v63": "The teaser is the free part.",
    "paywall.line.v64": "Subscription pending review.",
    "paywall.line.v65": "The rest is membership.",
    "paywall.line.v66": "The rest is membership.",
    "paywall.line.v67": "Approval takes time and universes.",
    "paywall.line.v68": "The desk holds the line.",
    "paywall.line.v69": "Approval takes time and universes.",
    "paywall.line.v70": "The wall remains a wall.",
    "paywall.line.v71": "Subscription pending review.",
    "paywall.line.v72": "Continue behind the desk.",
    "paywall.line.v73": "Continue behind the desk.",
    "paywall.line.v74": "The wall remains a wall.",
    "paywall.line.v75": "Nothing personal. Policy.",
    "paywall.line.v76": "Reading beyond costs patience.",
    "paywall.line.v77": "The rest is membership.",
    "paywall.line.v78": "The rest is membership.",
    "paywall.line.v79": "Nothing personal. Policy.",
    "paywall.line.v80": "The wall remains a wall.",
    "paywall.line.v81": "Subscription pending review.",
    "paywall.line.v82": "Nothing personal. Policy.",
    "paywall.line.v83": "The teaser is the free part.",
    "paywall.line.v84": "Continue behind the desk.",
    "paywall.line.v85": "Approval takes time and universes.",
    "paywall.line.v86": "Reading beyond costs patience.",
    "paywall.line.v87": "The desk holds the line.",
    "paywall.line.v88": "Approval takes time and universes.",
    "paywall.line.v89": "Reviews take universes.",
    "paywall.line.v90": "Nothing personal. Policy.",
    "paywall.line.v91": "Subscription pending review.",
    "paywall.line.v92": "The desk holds the line.",
    "paywall.line.v93": "The teaser is the free part.",
    "paywall.line.v94": "Continue behind the desk.",
    "paywall.line.v95": "Reviews take universes.",
    "paywall.line.v96": "Reading beyond costs patience.",
    "paywall.line.v97": "The wall remains a wall.",
    "paywall.line.v98": "Approval takes time and universes.",
    "paywall.line.v99": "Nothing personal. Policy.",
    "paywall.line.v100": "The wall remains a wall.",
    "paywall.line.v101": "Subscription pending review.",
    "paywall.line.v102": "The rest is membership.",
    "paywall.line.v103": "The teaser is the free part.",
    "paywall.line.v104": "Continue behind the desk.",
    "paywall.line.v105": "The rest is membership.",
    "premium.note.v1": "Premium travels sealed",
    "premium.note.v2": "The dispatch stays sealed",
    "premium.note.v3": "Registration does not open it",
    "premium.note.v4": "The dispatch stays sealed",
    "premium.note.v5": "Editors only",
    "premium.note.v6": "Sealed dispatch",
    "premium.note.v7": "Not for the wall; for the seal",
    "premium.note.v8": "Editors only",
    "premium.note.v9": "The reader is ready; the seal is not",
    "premium.note.v10": "The reader is ready; the seal is not",
    "premium.note.v11": "The dispatch stays sealed",
    "premium.note.v12": "The seal is checked first",
    "premium.note.v13": "Registration does not open it",
    "premium.note.v14": "Registration does not open it",
    "premium.note.v15": "The dispatch stays sealed",
    "premium.note.v16": "Editors only",
    "premium.note.v17": "Editors only",
    "premium.note.v18": "The reader is ready; the seal is not",
    "premium.note.v19": "Editors only",
    "premium.note.v20": "Sealed dispatch",
    "premium.note.v21": "Registration does not open it",
    "premium.note.v22": "Editors only",
    "premium.note.v23": "Not for the wall; for the seal",
    "premium.note.v24": "Registration does not open it",
    "premium.note.v25": "Sealed. Truly.",
    "premium.note.v26": "Not for the wall; for the seal",
    "premium.note.v27": "Not for the wall; for the seal",
    "premium.note.v28": "Sealed dispatch",
    "premium.note.v29": "Authorization is editorial",
    "premium.note.v30": "Premium travels sealed",
    "premium.note.v31": "Not for the wall; for the seal",
    "premium.note.v32": "The seal is checked first",
    "premium.note.v33": "Registration does not open it",
    "premium.note.v34": "The dispatch stays sealed",
    "premium.note.v35": "The dispatch stays sealed",
    "premium.note.v36": "Authorization is editorial",
    "premium.note.v37": "Not for the wall; for the seal",
    "premium.note.v38": "The reader is ready; the seal is not",
    "premium.note.v39": "Authorization is editorial",
    "premium.note.v40": "Sealed dispatch",
    "premium.note.v41": "Editors only",
    "premium.note.v42": "The seal is checked first",
    "premium.note.v43": "Editors only",
    "premium.note.v44": "Premium travels sealed",
    "premium.note.v45": "Sealed dispatch",
    "premium.note.v46": "Premium travels sealed",
    "premium.note.v47": "Registration does not open it",
    "premium.note.v48": "Premium travels sealed",
    "premium.note.v49": "Authorization is editorial",
    "premium.note.v50": "Sealed dispatch",
    "premium.note.v51": "Premium travels sealed",
    "premium.note.v52": "The seal is checked first",
    "premium.note.v53": "Registration does not open it",
    "premium.note.v54": "Not for the wall; for the seal",
    "premium.note.v55": "The dispatch stays sealed",
    "premium.note.v56": "Sealed. Truly.",
    "premium.note.v57": "Authorization is editorial",
    "premium.note.v58": "The reader is ready; the seal is not",
    "premium.note.v59": "Premium travels sealed",
    "premium.note.v60": "Sealed dispatch",
    "premium.note.v61": "Not for the wall; for the seal",
    "premium.note.v62": "Authorization is editorial",
    "premium.note.v63": "Premium travels sealed",
    "premium.note.v64": "Sealed dispatch",
    "premium.note.v65": "The dispatch stays sealed",
    "premium.note.v66": "Registration does not open it",
    "premium.note.v67": "Authorization is editorial",
    "premium.note.v68": "The reader is ready; the seal is not",
    "premium.note.v69": "Authorization is editorial",
    "premium.note.v70": "The seal is checked first",
    "premium.note.v71": "Registration does not open it",
    "premium.note.v72": "The reader is ready; the seal is not",
    "premium.note.v73": "Registration does not open it",
    "premium.note.v74": "Premium travels sealed",
    "premium.note.v75": "The dispatch stays sealed",
    "premium.note.v76": "Sealed. Truly.",
    "premium.note.v77": "The seal is checked first",
    "premium.note.v78": "Registration does not open it",
    "premium.note.v79": "The seal is checked first",
    "premium.note.v80": "Not for the wall; for the seal",
    "premium.note.v81": "Editors only",
    "premium.note.v82": "The seal is checked first",
    "premium.note.v83": "Registration does not open it",
    "premium.note.v84": "Sealed. Truly.",
    "premium.note.v85": "Not for the wall; for the seal",
    "premium.note.v86": "Sealed. Truly.",
    "premium.note.v87": "Registration does not open it",
    "premium.note.v88": "Registration does not open it",
    "premium.note.v89": "Not for the wall; for the seal",
    "premium.note.v90": "Sealed dispatch",
    "mascot.line.v1": "The duck is not the duck.",
    "mascot.line.v2": "The heron abstained.",
    "mascot.line.v3": "The duck is not the duck.",
    "mascot.line.v4": "Mascot litigation pending.",
    "mascot.line.v5": "Mascot litigation pending.",
    "mascot.line.v6": "Two pigeons were consulted.",
    "mascot.line.v7": "The heron abstained.",
    "mascot.line.v8": "The capybara has no comment.",
    "mascot.line.v9": "Two pigeons were consulted.",
    "mascot.line.v10": "The capybara has no comment.",
    "mascot.line.v11": "The capybara has no comment.",
    "mascot.line.v12": "Mascot unavailable for comment.",
    "mascot.line.v13": "The capybara has no comment.",
    "mascot.line.v14": "Mascot litigation pending.",
    "mascot.line.v15": "The duck is not the duck.",
    "mascot.line.v16": "The heron abstained.",
    "mascot.line.v17": "The mascot declines.",
    "mascot.line.v18": "The capybara has no comment.",
    "mascot.line.v19": "Mascot hours: never",
    "mascot.line.v20": "The mascot is fine.",
    "mascot.line.v21": "The mascot is fine.",
    "mascot.line.v22": "The heron abstained.",
    "mascot.line.v23": "Mascot hours: never",
    "mascot.line.v24": "Mascot litigation pending.",
    "mascot.line.v25": "The duck is not the duck.",
    "mascot.line.v26": "Mascot unavailable for comment.",
    "mascot.line.v27": "Mascot unavailable for comment.",
    "mascot.line.v28": "The capybara has no comment.",
    "mascot.line.v29": "Mascot hours: never",
    "mascot.line.v30": "The heron abstained.",
    "mascot.line.v31": "The mascot sends regards.",
    "mascot.line.v32": "Mascot hours: never",
    "mascot.line.v33": "The heron abstained.",
    "mascot.line.v34": "Mascot hours: never",
    "mascot.line.v35": "The duck is not the duck.",
    "mascot.line.v36": "Two pigeons were consulted.",
    "mascot.line.v37": "Mascot hours: never",
    "mascot.line.v38": "Mascot hours: never",
    "mascot.line.v39": "Mascot hours: never",
    "mascot.line.v40": "Mascot litigation pending.",
    "mascot.line.v41": "Mascot hours: never",
    "mascot.line.v42": "The heron abstained.",
    "mascot.line.v43": "The mascot declines.",
    "mascot.line.v44": "The duck is not the duck.",
    "mascot.line.v45": "Mascot litigation pending.",
    "mascot.line.v46": "Two pigeons were consulted.",
    "mascot.line.v47": "The capybara has no comment.",
    "mascot.line.v48": "Two pigeons were consulted.",
    "mascot.line.v49": "Mascot hours: never",
    "mascot.line.v50": "The mascot is fine.",
    "mascot.line.v51": "The mascot sends regards.",
    "mascot.line.v52": "The heron abstained.",
    "mascot.line.v53": "The mascot declines.",
    "mascot.line.v54": "Two pigeons were consulted.",
    "mascot.line.v55": "The duck is not the duck.",
    "mascot.line.v56": "Two pigeons were consulted.",
    "mascot.line.v57": "Mascot hours: never",
    "mascot.line.v58": "Mascot hours: never",
    "mascot.line.v59": "Mascot hours: never",
    "mascot.line.v60": "The mascot is fine.",
    "mascot.line.v61": "Mascot hours: never",
    "mascot.line.v62": "The heron abstained.",
    "mascot.line.v63": "The duck is not the duck.",
    "mascot.line.v64": "Mascot hours: never",
    "mascot.line.v65": "Mascot hours: never",
    "mascot.line.v66": "The capybara has no comment.",
    "mascot.line.v67": "The duck is not the duck.",
    "mascot.line.v68": "The capybara has no comment.",
    "mascot.line.v69": "Mascot hours: never",
    "mascot.line.v70": "Mascot hours: never",
    "mascot.line.v71": "The mascot sends regards.",
    "mascot.line.v72": "The mascot declines.",
    "mascot.line.v73": "Two pigeons were consulted.",
    "mascot.line.v74": "The mascot declines.",
    "mascot.line.v75": "The duck is not the duck.",
    "mascot.line.v76": "The heron abstained.",
    "mascot.line.v77": "The heron abstained.",
    "mascot.line.v78": "The capybara has no comment.",
    "mascot.line.v79": "The mascot declines.",
    "mascot.line.v80": "Mascot unavailable for comment.",
    "mascot.line.v81": "The duck is not the duck.",
    "mascot.line.v82": "The duck is not the duck.",
    "mascot.line.v83": "The duck is not the duck.",
    "mascot.line.v84": "The mascot is fine.",
    "mascot.line.v85": "The duck is not the duck.",
    "mascot.line.v86": "Two pigeons were consulted.",
    "mascot.line.v87": "The heron abstained.",
    "mascot.line.v88": "Mascot litigation pending.",
    "mascot.line.v89": "Mascot hours: never",
    "mascot.line.v90": "The mascot is fine.",
    "bridge.line.v1": "The bridge is closed for paper.",
    "bridge.line.v2": "Mind the corridor.",
    "bridge.line.v3": "The ferry precedes the bridge.",
    "bridge.line.v4": "Bridge hours: tidal",
    "bridge.line.v5": "The bridge observes silence",
    "bridge.line.v6": "Bridge hours: tidal",
    "bridge.line.v7": "Return crossing free",
    "bridge.line.v8": "The bridge tilts, politely",
    "bridge.line.v9": "The bridge is closed for paper.",
    "bridge.line.v10": "The bridge is open.",
    "bridge.line.v11": "Crossing counted",
    "bridge.line.v12": "Bridge hours: tidal",
    "bridge.line.v13": "The ferry precedes the bridge.",
    "bridge.line.v14": "Bridge hours: tidal",
    "bridge.line.v15": "The bridge observes silence",
    "bridge.line.v16": "Crossing counted",
    "bridge.line.v17": "Bridge hours: tidal",
    "bridge.line.v18": "Mind the other side",
    "bridge.line.v19": "Mind the other side",
    "bridge.line.v20": "The bridge is open.",
    "bridge.line.v21": "The bridge tilts, politely",
    "bridge.line.v22": "Crossing counted",
    "bridge.line.v23": "The bridge is open.",
    "bridge.line.v24": "Bridge hours: tidal",
    "bridge.line.v25": "The ferry precedes the bridge.",
    "bridge.line.v26": "Mind the corridor.",
    "bridge.line.v27": "Return crossing free",
    "bridge.line.v28": "The bridge observes silence",
    "bridge.line.v29": "The bridge tilts, politely",
    "bridge.line.v30": "The bridge is open.",
    "bridge.line.v31": "The bridge is open.",
    "bridge.line.v32": "The bridge tilts, politely",
    "bridge.line.v33": "The bridge observes silence",
    "bridge.line.v34": "Bridge hours: tidal",
    "bridge.line.v35": "The bridge observes silence",
    "bridge.line.v36": "The bridge tilts, politely",
    "bridge.line.v37": "Return crossing free",
    "bridge.line.v38": "The bridge is closed for paper.",
    "bridge.line.v39": "Bridge hours: tidal",
    "bridge.line.v40": "Crossing counted",
    "bridge.line.v41": "Mind the other side",
    "bridge.line.v42": "Mind the corridor.",
    "bridge.line.v43": "The bridge is open.",
    "bridge.line.v44": "Bridge hours: tidal",
    "bridge.line.v45": "The bridge is closed for paper.",
    "bridge.line.v46": "Crossing counted",
    "bridge.line.v47": "The ferry precedes the bridge.",
    "bridge.line.v48": "Bridge hours: tidal",
    "bridge.line.v49": "The bridge tilts, politely",
    "bridge.line.v50": "Bridge hours: tidal",
    "bridge.line.v51": "Bridge hours: tidal",
    "bridge.line.v52": "Mind the corridor.",
    "bridge.line.v53": "The ferry precedes the bridge.",
    "bridge.line.v54": "Bridge hours: tidal",
    "bridge.line.v55": "The bridge tilts, politely",
    "bridge.line.v56": "Crossing counted",
    "bridge.line.v57": "Return crossing free",
    "bridge.line.v58": "Crossing counted",
    "bridge.line.v59": "Mind the corridor.",
    "bridge.line.v60": "Crossing counted",
    "bridge.line.v61": "The bridge is closed for paper.",
    "bridge.line.v62": "Mind the corridor.",
    "bridge.line.v63": "The ferry precedes the bridge.",
    "bridge.line.v64": "Bridge hours: tidal",
    "bridge.line.v65": "Mind the corridor.",
    "bridge.line.v66": "Crossing counted",
    "bridge.line.v67": "Return crossing free",
    "bridge.line.v68": "Crossing counted",
    "bridge.line.v69": "Mind the corridor.",
    "bridge.line.v70": "The bridge tilts, politely",
    "bridge.line.v71": "Return crossing free",
    "bridge.line.v72": "Mind the corridor.",
    "bridge.line.v73": "The bridge is open.",
    "bridge.line.v74": "The bridge observes silence",
    "bridge.line.v75": "The bridge observes silence",
    "archive.line.v1": "Ask the plate ledger.",
    "archive.line.v2": "The archive locks for symmetry.",
    "archive.line.v3": "Bound volumes, roughly bound.",
    "archive.line.v4": "Older news, same ink.",
    "archive.line.v5": "Bound volumes, roughly bound.",
    "archive.line.v6": "Bound volumes, roughly bound.",
    "archive.line.v7": "Dust is a feature.",
    "archive.line.v8": "Older editions live here.",
    "archive.line.v9": "The archive locks for symmetry.",
    "archive.line.v10": "Older news, same ink.",
    "archive.line.v11": "Ask the plate ledger.",
    "archive.line.v12": "Older news, same ink.",
    "archive.line.v13": "The archive remembers so you choose not to.",
    "archive.line.v14": "Ask the plate ledger.",
    "archive.line.v15": "Retired plates rest here.",
    "archive.line.v16": "Older editions live here.",
    "archive.line.v17": "The archive locks for symmetry.",
    "archive.line.v18": "Dust is a feature.",
    "archive.line.v19": "Ask the plate ledger.",
    "archive.line.v20": "Retired plates rest here.",
    "archive.line.v21": "The archive remembers so you choose not to.",
    "archive.line.v22": "Bound volumes, roughly bound.",
    "archive.line.v23": "Dust is a feature.",
    "archive.line.v24": "Older editions live here.",
    "archive.line.v25": "The archive locks for symmetry.",
    "archive.line.v26": "Dust is a feature.",
    "archive.line.v27": "The archive remembers so you choose not to.",
    "archive.line.v28": "Retired plates rest here.",
    "archive.line.v29": "Dust is a feature.",
    "archive.line.v30": "Bound volumes, roughly bound.",
    "archive.line.v31": "Dust is a feature.",
    "archive.line.v32": "The archive locks for symmetry.",
    "archive.line.v33": "The archive locks for symmetry.",
    "archive.line.v34": "Retired plates rest here.",
    "archive.line.v35": "Ask the plate ledger.",
    "archive.line.v36": "Older news, same ink.",
    "archive.line.v37": "Dust is a feature.",
    "archive.line.v38": "The archive remembers so you choose not to.",
    "archive.line.v39": "Dust is a feature.",
    "archive.line.v40": "Older editions live here.",
    "archive.line.v41": "The archive locks for symmetry.",
    "archive.line.v42": "Bound volumes, roughly bound.",
    "archive.line.v43": "Retired plates rest here.",
    "archive.line.v44": "Retired plates rest here.",
    "archive.line.v45": "The archive remembers so you choose not to.",
    "archive.line.v46": "Bound volumes, roughly bound.",
    "archive.line.v47": "Older editions live here.",
    "archive.line.v48": "Older editions live here.",
    "archive.line.v49": "The archive locks for symmetry.",
    "archive.line.v50": "Dust is a feature.",
    "archive.line.v51": "Ask the plate ledger.",
    "archive.line.v52": "Older news, same ink.",
    "archive.line.v53": "Dust is a feature.",
    "archive.line.v54": "Bound volumes, roughly bound.",
    "archive.line.v55": "Retired plates rest here.",
    "archive.line.v56": "Older news, same ink.",
    "archive.line.v57": "The archive locks for symmetry.",
    "archive.line.v58": "Dust is a feature.",
    "archive.line.v59": "Ask the plate ledger.",
    "archive.line.v60": "Older news, same ink.",
    "archive.line.v61": "Older news, same ink.",
    "archive.line.v62": "The archive remembers so you choose not to.",
    "archive.line.v63": "Retired plates rest here.",
    "archive.line.v64": "Older editions live here.",
    "archive.line.v65": "Retired plates rest here.",
    "archive.line.v66": "Dust is a feature.",
    "archive.line.v67": "Ask the plate ledger.",
    "archive.line.v68": "Older news, same ink.",
    "archive.line.v69": "The archive remembers so you choose not to.",
    "archive.line.v70": "Older editions live here.",
    "archive.line.v71": "Retired plates rest here.",
    "archive.line.v72": "Bound volumes, roughly bound.",
    "archive.line.v73": "Ask the plate ledger.",
    "archive.line.v74": "Older editions live here.",
    "archive.line.v75": "Bound volumes, roughly bound.",
    "section.name.0": "Front",
    "section.name.1": "Bureaus",
    "section.name.2": "Multiverse",
    "section.name.3": "Corrections",
    "section.name.4": "Weather (all)",
    "section.name.5": "Ferry desk",
    "section.name.6": "Archive",
    "section.name.7": "Print",
    "reader.greeting.formal": "Your universe of record stands confirmed.",
    "capsule.tracking.7f3a": "5029b24a363d61c88074544b8f3c88bc"
  }
}
